<h4><u>Quote Details</u></h4>
<div class="row">
    <div class="col-md-7">
        <div class="row mb-3">
            <div class="col-md-6"><label>Cover From:</label></div>
            <div class="col-md-6">
                <input type="text" name="cover_from" [value]="quote.policy_start_date | date:'dd-MM-yyyy'"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>Cover To:</label></div>
            <div class="col-md-6">
                <input type="text" name="cover_to" [value]="CoverTo | date:'dd-MM-yyyy'"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>Product:</label></div>
            <div class="col-md-6">
                <input type="text" name="product" value="Saddlery & Tack" class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>Broker:</label></div>
            <div class="col-md-6">
                <input type="text" name="broker"
                    [value]="quote &&quote.broker_name?quote.broker_name:'Peliwica Limited'"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3" *ngIf="quote && quote.type == 3">
            <div class="col-md-6"><label>Effective Date:</label></div>
            <div class="col-md-6">
                <input type="text" name="cover_from" [value]="quote.effective_date | date:'dd-MM-yyyy'"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3" *ngIf="quote && quote.type == 4">
            <div class="col-md-6"><label>Cancel Date:</label></div>
            <div class="col-md-6">
                <input type="text" name="cover_from" [value]="quote.effective_date | date:'dd-MM-yyyy'"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>Transaction Date:</label></div>
            <div class="col-md-6" *ngIf="quote">
                <input type="text" name="transactional_date" [value]="quote.transactional_date | date:'dd-MM-yyyy'"
                    class="form-control form-control-sm" readonly>
            </div>
            <div class="col-md-6" *ngIf="!quote">
                <input type="text" name="transactional_date" [value]="" class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>Transaction Type:</label></div>
            <div class="col-md-6">
                <input type="text" name="transction_type" [(ngModel)]="transction_type" readonly
                    class="form-control form-control-sm">
            </div>
        </div>
        <div class="row mb-3" *ngIf="quote.mta_reason_id">
            <div class="col-md-6"><label>Policy Reason:</label></div>
            <div class="col-md-6">
                <div *ngIf="quote.mta_reason_id != '1'">
                    <input type="text" name="policy_reason" [(ngModel)]="policyReason"
                        class="form-control form-control-sm">
                </div>
                <div *ngIf="quote.mta_reason_id == '1'">
                    <input type="text" name="policy_reason" [(ngModel)]="quote.mta_reason_other" readonly
                        class="form-control form-control-sm">
                </div>
            </div>
        </div>
    </div>
</div>

<h4><u>Proposer Details</u></h4>
<div class="row">
    <div class="col-md-7">
        <div class="row mb-3">
            <div class="col-md-6"><label>Customer type:</label></div>
            <div class="col-md-6">
                <input type="text" name="proposer_type" [value]="proposer_type" class="form-control form-control-sm"
                    readonly>
            </div>
        </div>
        <!--- Company Details   -->
        <div *ngIf="quote.policy_holder.proposer_type == 'company' || quote.policy_holder.proposer_type == 'joint'">
            <div class="row mb-3">
                <div class="col-md-6"><label>Is this client a Micro-enterprise?</label></div>
                <div class="col-md-6">
                    <mat-radio-group class="row" aria-label="Select an option" name="micro_enterprise" disabled>
                        <div class="col-md-6">
                            <div class="quote_radio">
                                <mat-radio-button value="1"
                                    [checked]="quote.policy_holder.is_micro_enterprise">Yes</mat-radio-button>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="quote_radio">
                                <mat-radio-button value="2"
                                    [checked]="!quote.policy_holder.is_micro_enterprise">No</mat-radio-button>
                            </div>
                        </div>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>{{(quote.policy_holder.proposer_type == 'joint')?'Names':'Company
                        Name'}}:</label></div>
                <div class="col-md-6">
                    <input type="text" name="company_name" [value]="quote.policy_holder.company_name | titlecase"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Trading Name:</label></div>
                <div class="col-md-6">
                    <input type="text" name="trading_name" [value]="quote.policy_holder.trading_name | titlecase"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3" *ngIf="quote.policy_holder.proposer_type == 'company'">
                <div class="col-md-6"><label>Year Company Established:</label></div>
                <div class="col-md-6">
                    <input type="text" name="year" [value]="quote.policy_holder.year_of_establishment"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
            <!-- <div class="row mb-3">
                <div class="col-md-6"><label>Rating Type:</label></div>
                <div class="col-md-6">
                    <input type="text" name="year" [value]="quote.rating_type | uppercase"
                        class="form-control form-control-sm" readonly>
                </div>
            </div> -->
        </div>

        <!--- Individual Details -->
        <!-- <div *ngIf="quote.policy_holder.proposer_type == 'individual'"> -->
            <div class="row mb-3">
                <div class="col-md-6"><label>Title:</label></div>
                <div class="col-md-6">
                    <input type="text" name="title" [value]="quote.policy_holder.title | titlecase"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>First Name:</label></div>
                <div class="col-md-6">
                    <input type="text" name="first_name" [value]="quote.policy_holder.first_name | titlecase"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Last Name:</label></div>
                <div class="col-md-6">
                    <input type="text" name="last_name" [value]="quote.policy_holder.last_name | titlecase"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Date Of Birth:</label></div>
                <div class="col-md-6">
                    <input type="text" name="dob" [value]="quote.policy_holder.dob | date:'dd-MM-yyyy'"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
        <!-- </div> -->

        <!--  Address Details -->
        <h6><u>Address Details</u></h6>
        <div class="row mb-3">
            <div class="col-md-6"><label>Address Line 1:</label></div>
            <div class="col-md-6">
                <input type="text" name="line1" [value]="quote.policy_holder.address.address1"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>Address Line 2:</label></div>
            <div class="col-md-6">
                <input type="text" name="line2" [value]="quote.policy_holder.address.address2"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>Address Line 3:</label></div>
            <div class="col-md-6">
                <input type="text" name="line3" [value]="quote.policy_holder.address.address3"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>County:</label></div>
            <div class="col-md-6">
                <input type="text" name="county" [value]="quote.policy_holder.address.city"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>Postcode:</label></div>
            <div class="col-md-6">
                <input type="text" name="postcode" [value]="quote.policy_holder.address.postcode"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
    </div>
</div>




<div>
    <h4><u>Contact Details</u></h4>
    <div class="row">
        <div class="col-md-7">
            <div class="row mb-3">
                <div class="col-md-6"><label>Email: </label></div>
                <div class="col-md-6">
                    <input type="text" name="email" [value]="quote?.email" class="form-control form-control-sm"
                        readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Phone: </label></div>
                <div class="col-md-6">
                    <input type="text" name="phone" [value]="quote?.phone" class="form-control form-control-sm"
                        readonly>
                </div>
            </div>

            <div class="row mb-3" *ngIf="isAdmin">
                <div class="col-md-6"><label>Preferred ways to hear:</label></div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-3">
                            <mat-radio-group class="row" aria-label="Select an option" name="is_phone" disabled>
                                <div class="quote_radio">
                                    <mat-radio-button value="1"
                                        [checked]="quote?.is_phone == 1">Phone</mat-radio-button>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div class="col-md-3">
                            <mat-radio-group class="row" aria-label="Select an option" name="sms" disabled>
                                <div class="quote_radio">
                                    <mat-radio-button value="1" [checked]="quote?.sms == 1">Text</mat-radio-button>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div class="col-md-3">
                            <mat-radio-group class="row" aria-label="Select an option" name="is_email" disabled>
                                <div class="quote_radio">
                                    <mat-radio-button value="1"
                                        [checked]="quote?.is_email == 1">Email</mat-radio-button>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div class="col-md-3">
                            <mat-radio-group class="row" aria-label="Select an option" name="post" disabled>
                                <div class="quote_radio">
                                    <mat-radio-button value="1" [checked]="quote?.post == 1">Post</mat-radio-button>
                                </div>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>

<!-- <div class="row" *ngIf="isAdmin">
    <div class="col-md-7">
        <div class="row mb-3">
            <div class="col-md-6"><label>Affinity Partner: </label></div>
            <div class="col-md-6">
                <input type="text" name="affinity_partner" [value]="quote && quote.affinity_partner?quote.affinity_partner:''" class="form-control form-control-sm" readonly>
            </div>
        </div>
    </div>
</div> -->